import React, {Component} from 'react';
import {Form,FormGroup,ControlLabel} from 'react-bootstrap'
import Select from 'react-select'

class SelectFormInline extends Component {
  constructor(...args){
    super(...args)

    this.state = {}
  }

  render(){
    let {name,label,options,value,placeholder,clearable,onChange,hightlight,labelWidth}  = this.props
    let state = this.state
    let className = '',elementWidth = '120px'
    if(typeof hightlight!=='undefined')
      className = 'text-lipstick text-bold'

    if(typeof labelWidth !=='undefined'){
      elementWidth = 'calc(100% - '+labelWidth+'px)'
    }
    return (
      <Form inline>
        <FormGroup controlId={"formInline"+name} style={{marginRight:'15px'}} >
          <ControlLabel className={className}>{label} : </ControlLabel>
        </FormGroup>
        <div className={'form-group '} style={{width:elementWidth}}>
          <Select
              name={"Select"+name}
              placeholder={(typeof placeholder ==='undefined')?"Select value":placeholder}
              value={value}
              options={options}
              onChange={onChange}
              clearable={clearable}
              />
          </div>
      </Form>
    )
  }
}

export default SelectFormInline



// WEBPACK FOOTER //
// ./src/component/element/SelectFormInline.js